import React from "react";
import "./Button.scss"
const SecondaryButton = ({ isPrimary = true, buttonText, onClick, fontSize, fontWeight, width }) => {
    return (
        <div
            className={isPrimary ? "Witearn-SecondaryButton-primary" : "Witearn-SecondaryButton-secondary"}
            onClick={onClick}
            style={{ fontSize, fontWeight, width }}>
            {buttonText}
        </div >
    )
}
export default SecondaryButton